module.exports = __webpack_public_path__ + "static/media/Gallery-22.a9391570.jpg";